import React, { useState } from 'react'
import { Modal, Steps } from 'antd'
import { connect } from 'react-redux'
import { actions } from '../../../../../../../store/reducers/assignments.reducer'
import UploadAnswerKey from './steps/UploadAnswerKey'
import DetermineAnalysisType from './steps/DetermineAnalysisType'
import UploadSubmissionsZip from './steps/UploadSubmissionsZip'
import { actions as authorizedLayoutActions } from '../../../../../../../store/reducers/authorized-layout.reducer'

const CreateExcelAssignmentModal = ({ setShowCreateExcelAssignmentModal }) => {
    const [currentStep, setCurrentStep] = useState(0)

    const moveToNextStep = () => {
        setCurrentStep(currentStep + 1)
    }

    const handleCancel = () => {
        setShowCreateExcelAssignmentModal(false)
    }

    const stepItems = [
        { title: 'Answer Key' },
        { title: 'Analysis Type' },
        { title: 'Submissions' },
    ]

    const stepContents = [
        <UploadAnswerKey key='answer-key' moveToNextStep={moveToNextStep} />,
        <DetermineAnalysisType key='analysis-type' moveToNextStep={moveToNextStep} />,
        <UploadSubmissionsZip key='submissions' />,
    ]

    return (
        <Modal open title='Create Excel assignment' onCancel={handleCancel} footer={null}>
            <Steps className='mb-32' current={currentStep} size='small' items={stepItems} />
            <div>{stepContents[currentStep]}</div>
        </Modal>
    )
}

const mapState = ({ assignments }) => {
    return {
        submissionsFileList: assignments.submissionsFileList,
        isWaitingForFileToUpload: assignments.isWaitingForFileToUpload,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowCreateExcelAssignmentModal(value) {
            dispatch(authorizedLayoutActions.setShowCreateExcelAssignmentModal(value))
        },
        setSubmissionsFileList(value) {
            dispatch(actions.setSubmissionsFileList(value))
        },
    }
}

export default connect(mapState, mapDispatch)(CreateExcelAssignmentModal)
